// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__1CgQX","addWidgetButton":"Header_addWidgetButton__3EQT2","dashboardTabs":"Header_dashboardTabs__3xNI1","active":"Header_active__XcYNM"};